import { useState, useEffect } from "react";
import { SettingsContext } from "./SettingsContext";

const SettingsProvider = ({ children }) => {
  const [furigana, setFurigana] = useState(
    localStorage.getItem("setting_furigana")
      ? JSON.parse(localStorage.getItem("setting_furigana"))
      : true
  );
  const [romanji, setRomanji] = useState(
    localStorage.getItem("setting_romanji")
      ? JSON.parse(localStorage.getItem("setting_romanji"))
      : true
  );

  useEffect(() => {
    if (furigana !== JSON.parse(localStorage.getItem("setting_furigana")))
      localStorage.setItem("setting_furigana", furigana);
    if (romanji !== JSON.parse(localStorage.getItem("setting_romanji")))
      localStorage.setItem("setting_romanji", romanji);
  }, [furigana, romanji]);

  return (
    <SettingsContext.Provider
      value={{
        furigana,
        romanji,
        setFurigana,
        setRomanji,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsProvider;
